/**
 * @file Navbar.tsx
 * @description
 * -----------------------------------------------------
 * Archivo que contiene el componente de Nav
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2025-03-17
 * @modified 2025-09-26
 * @author DLTCode
 * @author Ismael Benabdellah
 * @author Nacho Moya
 * @copyright © DLTCode
 * @license Private
 * */

"use client";

import { c as _c } from "react/compiler-runtime";
import { Link, usePathname } from "@/features/i18n";
import { useTranslations } from "next-intl";
import ImageComponent from "@/components/ui/ImageComponent";
import ThemeToggle from "@/components/ui/ThemeToggle";
import clsx from "clsx";
import LocaleToggle from "./LocaleToggle";
import useAppData from "@/hooks/useAppData";
import { LogIn } from "lucide-react";
const NavbarComponent = () => {
  const $ = _c(23);
  const pathname = usePathname();
  const t = useTranslations("NavComponent");
  const aria = useTranslations("Aria.Landing");
  const appData = useAppData();
  const t0 = pathname === "/" && "navbar--landing";
  let t1;
  if ($[0] !== t0) {
    t1 = clsx("navbar", t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== aria) {
    t2 = aria("primaryNavigation");
    $[2] = aria;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = appData.branding.logo;
  let t4;
  if ($[4] !== aria) {
    t4 = aria("goToLanding");
    $[4] = aria;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== appData.branding.logo || $[7] !== t4) {
    t5 = <Link href="/" className="navbar__brand"><ImageComponent src={t3} alt={t4} width={150} height={50} zoomable={false} preload={true} /></Link>;
    $[6] = appData.branding.logo;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <li className="navbar__menu-buttons"><ThemeToggle /><LocaleToggle /></li>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t) {
    t7 = t("login");
    $[10] = t;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t) {
    t8 = t("login");
    $[12] = t;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <LogIn size={18} aria-hidden={true} />;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t7 || $[16] !== t8) {
    t10 = <ul className="navbar__menu">{t6}<li className="navbar__menu-item"><Link className="btn btn--full btn--primary" href="/login" title={t7}>{t8}{t9}</Link></li></ul>;
    $[15] = t7;
    $[16] = t8;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t1 || $[19] !== t10 || $[20] !== t2 || $[21] !== t5) {
    t11 = <nav className={t1} aria-label={t2}>{t5}{t10}</nav>;
    $[18] = t1;
    $[19] = t10;
    $[20] = t2;
    $[21] = t5;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
};
export default NavbarComponent;